module.exports = __webpack_public_path__ + "img/20200514_154849.31f51af1.jpg";